import React from 'react';
import { FiGlobe } from 'react-icons/fi';
import ScannerDashboard from '../components/scanner/ScannerDashboard';
import './JobScanner.css';

const JobScanner = () => {
  return (
    <div className="job-scanner-page list-page">
      <div className="page-header">
        <h1><FiGlobe /> Job scanner</h1>
      </div>
      <ScannerDashboard />
    </div>
  );
};

export default JobScanner;
